// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__mfbnD","close":"style_close__2XJa7","title":"style_title__FoVaL","text":"style_text__4Fsd+","bottom_button":"style_bottom_button__9Tfk-"};